var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"rightMainContainer"}},[_c('navAndSearch',{on:{"pf5":_vm.parent5}}),_c('fileTable',{ref:"goodslist"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }